import NestedForm from '@stimulus-components/rails-nested-form'

export default class extends NestedForm {
  add(event) {
    event.preventDefault()

    const trigger = event.currentTarget
    const token = Date.now().toString()
    const childIndex = trigger.dataset.childIndex || 'NEW_RECORD'
    const content = this.templateTarget.innerHTML.replace(
      new RegExp(childIndex, 'g'),
      token,
    )

    const insertPosition = trigger.dataset.insertPosition || 'beforebegin'
    this.targetTarget.insertAdjacentHTML(insertPosition, content)

    this.element.dispatchEvent(
      new CustomEvent('components--nested-form:add', { bubbles: true }),
    )
  }

  remove(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    const confirmationMessage = trigger.dataset.confirmationMessage

    if (confirmationMessage && window.confirm(confirmationMessage)) {
      super.remove(event)
    } else if (!confirmationMessage) {
      super.remove(event)
    }
  }
}
